import { getParams } from '@/utils/params';
import { getRequest } from './methods/getRequest';
import { postRequest } from './methods/postRequest';
import { requestToJSON } from './methods/requestToJSON';
import { Params, addParamsToUrl } from './methods/urlParams';

export const getUrl = (url: string) => `/designer-service/v1/${url}`;

const addLocaleToParams = (params: Params = {}) => {
  params.locale = getParams().locale;
  return params;
};

export const fetchFromDesignerService = <ResponseType>(
  url: string,
  params?: Params,
  init?: RequestInit
) =>
  requestToJSON<ResponseType>(
    getRequest(addParamsToUrl(getUrl(url), addLocaleToParams(params)), init)
  );

export const postToDesignerService = <ResponseType>(
  url: string,
  data: unknown,
  params?: Params,
  init?: RequestInit
) => requestToJSON<ResponseType>(postRequest(addParamsToUrl(getUrl(url), params), data, init));
